import Entity from '../entity'
import Subject from './Subject';

export default class SubjectCategory extends Entity<number>{
    name: string  = null;
    keywords: string  = null;
    description: string  = null;
    coverImageUrl: string  = null;
    parentId: number  = null;
    bannerImageUrl: string  = null;
    tenantId: number  = null;
    isPublished: boolean;
    priority: number  = null;
    displayName: string  = null;
    remark: string  = null;
    subjects: Array<Subject>;
}